import LoyaltySkeleton from "components/atoms/LoyaltySkeleton/LoyaltySkeleton";
import "./styles.sass";

type LoyaltyUserAvatarProps = {
  avatar?: string;
  isLoading?: boolean;
};

const LoyaltyUserAvatar = ({ avatar, isLoading }: LoyaltyUserAvatarProps) => {
  return (
    <div className="LoyaltyUserAvatar">
      {isLoading && <LoyaltySkeleton />}
      {avatar ? (
        <img
          src={avatar}
          alt="user-avatar"
          className="LoyaltyUserAvatar__avatar"
        />
      ) : null}
    </div>
  );
};

export default LoyaltyUserAvatar;
